<template>
  <div class="frb frb-info" id="vindi-div" v-if="isActive">
    <input ref="radio_method" autocomplete="off" type="radio" :id="`radio-button-${methodCode}`" name="radio-button"
           @click="select" :checked="methodSelected"
           :value="`${methodCode}`"/>
    <label :for="`radio-button-${methodCode}`">
      <div class="card-body">
        <slot></slot>
        <p class="small mb-1 mt-2" v-if="showInvoiceFormLink">
                    <a href="#" @click.stop.prevent="onShowInvoiceForm">
                        {{ $parent.wantReceiveInvoiceMessage }}
                    </a>
        </p>
        <div id="div1" v-show="methodSelected">
          <hr>
          <form id="payment_form">
            <!-- Grid row -->
            <div class="form-row">
              <!-- Default input -->
              <div class="form-group col-md-6">
                <label for="card_holder">{{ formFields.name.label }}</label>
                <input type="text" v-model="formFields.name.value" id="card_holder" maxlength="35" name="card_holder"
                       :placeholder="formFields.name.placeholder"
                       class="form-control" :class="{'is-invalid': !formFields.name.validated}"/>
              </div>
              <div class="form-group col-md-6">
                <label for="cpfcnpj">{{ formFields.cpfCnpj.label }}</label>
                <input v-model="formFields.cpfCnpj.value" id="cpfcnpj" type="text" class="form-control"
                       :class="{'is-invalid': !formFields.cpfCnpj.validated}"
                       :placeholder="formFields.cpfCnpj.placeholder">
              </div>
              <div class="form-group col-md-6">
                <label for="street">{{ formFields.street.label }}</label>
                <input v-model="formFields.street.value" id="street" type="text" maxlength="35" class="form-control"
                       :class="{'is-invalid': !formFields.street.validated}"
                       :placeholder="formFields.street.placeholder">
              </div>
              <div class="form-group col-md-6">
                <label for="street">{{ formFields.streetNumber.label }}</label>
                <input v-model="formFields.streetNumber.value" id="streetNumber" maxlength="10" type="text"
                       class="form-control"
                       :class="{'is-invalid': !formFields.streetNumber.validated}"
                       :placeholder="formFields.streetNumber.placeholder">
              </div>
              <div class="form-group col-md-6">
                <label for="street">{{ formFields.district.label }}</label>
                <input v-model="formFields.district.value" id="district" maxlength="35" type="text" class="form-control"
                       :class="{'is-invalid': !formFields.district.validated}"
                       :placeholder="formFields.district.placeholder">
              </div>
              <div class="form-group col-md-6">
                <label for="city">{{ formFields.city.label }}</label>
                <input v-model="formFields.city.value" id="city" maxlength="25" type="text" class="form-control"
                       :class="{'is-invalid': !formFields.city.validated}"
                       :placeholder="formFields.city.placeholder">
              </div>
              <div class="form-group col-md-6">
                <label for="region">{{ formFields.region.label }}</label>
                <select v-model="formFields.region.value" id="region" type="text" class="form-control"
                       :class="{'is-invalid': !formFields.region.validated}">
                  <option value="">{{formFields.region.placeholder}}</option>
                  <option v-for="region in regionCodes" :value="region.code">{{region.name}}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="zipCode">{{ formFields.zipCode.label }}</label>
                <input v-model="formFields.zipCode.value" id="zipCode" maxlength="10" type="text" class="form-control"
                       :class="{'is-invalid': !formFields.zipCode.validated}"
                       :placeholder="formFields.zipCode.placeholder">
              </div>
            </div>
          </form>
        </div>
      </div>
    </label>
  </div>
</template>
<script>
// import Translations from "./insert-me-to-translate.vue";

import paymentMethodMixin from "../mixins/payment-method-mixin";
import isString from 'lodash/isString';

const loadCpfCnpjImask = () =>
    Promise.all([
      import(/* webpackChunkName: "chunk-cpf-cnpj" */ "@fnando/cpf"),
      import(/* webpackChunkName: "chunk-cpf-cnpj" */ "@fnando/cnpj"),
      import(/* webpackChunkName: "chunk-imask" */ "imask"),
    ]);
export default {
  name: "vindiboleto",
  mixins: [paymentMethodMixin],
  props: {
    'initSelected': {
      default: false,
      type: Boolean
    },
    'proxyUrl': {
      type: String
    },
    'methodName': {
      type: String
    },
    'methodCode': {
      type: String
    },
    'additionalFields': {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      email: this.initEmail,
      show_form: true,
      formFields: {
        name: {
          label: gettext('Name'),
          placeholder: gettext('Name'),
          validated: true,
          value: null,
          common: true
          // value: "Test user"
        },
        cpfCnpj: {
          // label: "CPF/CNPJ",
          label: "CPF",
          // placeholder: "CPF/CNPJ",
          placeholder: "CPF",
          validated: true,
          value: null,
          common: true
          // value: "977.942.249-85"
        },
        street: {
          label: gettext('Street'),
          placeholder: gettext('Street'),
          validated: true,
          value: null,
          common: true
          // value: "Street"
        },
        streetNumber: {
          label: gettext('Number'),
          placeholder: gettext('Number'),
          validated: true,
          value: null,
          common: true
        },
        city: {
          label: gettext('City'),
          placeholder: gettext('City'),
          validated: true,
          value: null,
          common: true
        },
        district: {
          label: gettext('District'),
          placeholder: gettext('District'),
          validated: true,
          value: null,
          common: true
        },
        region: {
          label: gettext('Region code'),
          placeholder: gettext('Region code'),
          validated: true,
          // values: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'],
          values: [
            {code: 'AC', name: 'Acre'},
            {code: 'AL', name: 'Alagoas'},
            {code: 'AP', name: 'Amapá'},
            {code: 'AM', name: 'Amazonas'},
            {code: 'BA', name: 'Bahia'},
            {code: 'CE', name: 'Ceará'},
            {code: 'DF', name: 'Distrito Federal'},
            {code: 'ES', name: 'Espírito Santo'},
            {code: 'GO', name: 'Goiás'},
            {code: 'MA', name: 'Maranhão'},
            {code: 'MT', name: 'Mato Grosso'},
            {code: 'MS', name: 'Mato Grosso do Sul'},
            {code: 'MG', name: 'Minas Gerais'},
            {code: 'PA', name: 'Pará'},
            {code: 'PB', name: 'Paraíba'},
            {code: 'PR', name: 'Paraná'},
            {code: 'PE', name: 'Pernambuco'},
            {code: 'PI', name: 'Piauí'},
            {code: 'RJ', name: 'Rio de Janeiro'},
            {code: 'RN', name: 'Rio Grande do Norte'},
            {code: 'RS', name: 'Rio Grande do Sul'},
            {code: 'RO', name: 'Rondônia'},
            {code: 'RR', name: 'Roraima'},
            {code: 'SC', name: 'Santa Catarina'},
            {code: 'SP', name: 'São Paulo'},
            {code: 'SE', name: 'Sergipe'},
            {code: 'TO', name: 'Tocantins'},
          ],
          value: "",
          common: true
          // value: "RJ"
        },
        zipCode: {
          label: gettext('Postal code'),
          placeholder: gettext('Postal code'),
          validated: true,
          value: null,
          common: true
          // value: "23545-037"
        }
      },
      validators: {
        isValidCnpj: () => false,   // changed in mounted
        isValidCpf: () => false,    // changed in mounted
        isValidRegion: (text) => text.match("^[a-zA-Z]{2}$"),
        isValidLen: function(text, length) {
          const check = text !== null && text.length > 0 && text.length <= length;
          return check;
        },
        isValidZipCode: (zip) => {
          if(zip=== null) return false;
          zip  = zip.replace( /\D/g,'');
          return zip.length === 8;
        }
      }
    }
  },
  computed: {
    regionCodes: function (){
      return this.formFields.region.values
    },
  },
  methods: {
    validated: function () {
      return this.validate();
    },
    select: function () {
      this.$store.dispatch("order/setPaymentMethod", this)
    },
    preparePayment: function () {
      return new Promise((resolve)=>{
        if (this.validated()) {
          resolve();
        }
      })
    },
    addVindiFields: function (data) {
      return data
    },
    addAdditionalFields: function (data) {
      data['cpfCnpj'] = this.formFields.cpfCnpj.value;
      data['name'] = this.formFields.name.value;
      data['street'] = this.formFields.street.value;
      data['street_number'] = this.formFields.streetNumber.value;
      data['district'] = this.formFields.district.value;
      data['region'] = this.formFields.region.value === "" ? null : this.formFields.region.value;
      data['city'] = this.formFields.city.value;
      data['zip_code'] = this.formFields.zipCode.value;
      data = this.addVindiFields(data);
      return data;

    },
    validate: function (allNot = false) {
      this.formFields.name.validated = this.validators.isValidLen(this.formFields.name.value,35);
      const isCpf = isString(this.formFields.cpfCnpj.value) && this.validators.isValidCpf(this.formFields.cpfCnpj.value, true); // use strict validation
      // let isCnpj = false;
      // if (!isCpf) {
      //   isCnpj = isString(this.formFields.cpfCnpj.value) && this.validators.isValidCnpj(this.formFields.cpfCnpj.value, true); // use strict validation
      // }
      this.formFields.cpfCnpj.validated = isCpf;
      if (this.additionalFields) {
        this.formFields.street.validated = this.validators.isValidLen(this.formFields.street.value,35)
        this.formFields.city.validated = this.validators.isValidLen(this.formFields.city.value,25)
        this.formFields.streetNumber.validated = this.validators.isValidLen(this.formFields.streetNumber.value,10)
        this.formFields.district.validated = this.validators.isValidLen(this.formFields.district.value,35)
        this.formFields.region.validated = this.validators.isValidRegion(this.formFields.region.value) !== null
        this.formFields.zipCode.validated = this.formFields.zipCode.value && this.validators.isValidZipCode(this.formFields.zipCode.value)
      }
      if (allNot) {
        return Object.values(this.formFields).filter(element => element.common).every(element => (!element.validated))
      } else {
        return Object.values(this.formFields).filter(element => element.common).every(element => {
          // console.log(`COMMON ${element.label} - ${element.value} - ${element.validated}`);
          return element.validated;
        })
      }
    }
  },
  mounted: function () {
    loadCpfCnpjImask().then(
        ([{isValid: isValidCpf}, {isValid: isValidCnpj}, imask]) => {
          this.validators.isValidCpf = isValidCpf;
          this.validators.isValidCnpj = isValidCnpj;
          this.imask = imask;
        }
    );

  }
}
</script>
